<div class="l-wrapper">
  <app-header></app-header>
  <div class="l-main-service">
    <div class="l-main-service__img">
      <img
        src="./../../../../assets/img/service-main.png"
        alt=""
        class="c-pc"
      />
      <img
        src="./../../../../assets/img/service-sp-main.png"
        alt=""
        class="c-sp"
      />
    </div>
  </div>
  <div class="l-main-service__content1">
    <div class="l-main-service__content1__img">
      <img src="./../../../../assets/img/service-content.png" alt="" />
    </div>
    <div class="l-main-service__content1__description">
      <h2 translate class="l-main-service__content1__description__title">
        {{ "service.content1.title" }}
      </h2>
      <img src="./../../../../assets/img/border.png" alt="" class="c-pc" />
      <div class="l-main-service__content1__description__content">
        <p translate class="c-top__content">
          {{ "service.content1.description.1" }}
        </p>
        <p translate class="c-top__content">
          {{ "service.content1.description.2" }}
        </p>
      </div>
    </div>
  </div>

  <div class="l-main-service__content2">
    <div class="l-main-service__content2__left">
      <img
        src="./../../../../assets/img/service-content1.png"
        alt=""
        class="c-pc"
      />
      <img
        src="./../../../../assets/img/service-content1-sp.png"
        alt=""
        class="c-sp"
      />
    </div>
    <div class="l-main-service__content2__right">
      <h2 translate class="l-main-service__content2__right__title">
        {{ "service.content2.title" }}
      </h2>
      <div class="l-main-service__content2__right__description">
        <p translate>
          {{ "service.content2.description.1" }}
        </p>
        <p translate>
          {{ "service.content2.description.2" }}
        </p>
      </div>
    </div>
  </div>

  <div class="l-main-service__content3">
    <div class="l-main-service__content3__left">
      <h2 translate class="l-main-service__content3__left__title">
        {{ "service.content3.title" }}
      </h2>
      <div class="l-main-service__content3__left__description">
        <p translate>
          {{ "service.content3.description.1" }}
        </p>
        <p translate>
          {{ "service.content3.description.2" }}
        </p>
        <p translate>
          {{ "service.content3.description.3" }}
        </p>
      </div>
    </div>
    <div class="l-main-service__content3__right">
      <img
        src="./../../../../assets/img/service-content2.png"
        alt=""
        class="c-pc"
      />
      <img
        src="./../../../../assets/img/service-content2-sp.png"
        alt=""
        class="c-sp"
      />
    </div>
  </div>

  <app-footer></app-footer>
</div>
